import React, { useState, useEffect } from "react"

//controls
import {
  Button,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
  InputGroup,
} from "reactstrap"
import Flatpickr from "react-flatpickr"
import Switch from "react-switch"

//react form
//react form
import { FormProvider, useForm, Controller } from "react-hook-form"

//navigation
import { Link, useNavigate, useParams } from "react-router-dom"

//validation
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

//redux
import { useSelector, useDispatch } from "react-redux"

//custom hooks
import { useDeepCompareEffect } from "hooks"
import { isEmpty } from "lodash"
import { updateBasicSettings as OnUpdateBasicSettings } from "store/actions"
import { OnSymbol, Offsymbol } from "helpers/switch_helper"

const formdefault = {
  ZoomClientID: "",
  ZoomClientSecret: "",
  EnableZoom: true,
}
function ZoomTab() {
  const dispatch = useDispatch()
  const { basicSetting } = useSelector(state => state.Layout)
  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    ZoomClientID: yup.string().nullable(),
    ZoomClientSecret: yup.string().nullable(),
    EnableZoom: yup.bool(),
  })

  const methods = useForm({
    mode: "onChange",
    defaultValues: formdefault,
    resolver: yupResolver(schema),
  })
  const { reset, control, formState, setValue, getValues, trigger } = methods
  const { errors, isValid } = formState

  useDeepCompareEffect(() => {
    function updateZoomState() {
      //reset form with server data
      if (basicSetting) {
        const response = {
          ...basicSetting,
        }
        reset(response)
      }
    }

    updateZoomState()
  }, [dispatch, basicSetting])

  const handleSave = () => {
    trigger() //for form validation
    if (isValid) {
      dispatch(OnUpdateBasicSettings({ ...getValues(), BasicSettingID: 1 }))
      // reset(formdefault)
    }
  }

  return (
    <FormProvider {...methods}>
      <Row>
        <Col lg={6}>
          <div className="mb-3">
            <Label>Client ID</Label>
            <Controller
              name="ZoomClientID"
              control={control}
              render={({ field }) => (
                <>
                  <Input
                    {...field}
                    id="ZoomClientID"
                    type="text"
                    // required
                    //  invalid={!!errors.ZoomClientID}
                  />
                  {/* {errors?.ZoomClientID?.message ? (
                    <FormFeedback type="invalid" className="d-block">
                      {errors?.ZoomClientID?.message}
                    </FormFeedback>
                  ) : null} */}
                </>
              )}
            />
          </div>
          <div className="mb-3">
            <Label>Client Secret Key</Label>
            <Controller
              name="ZoomClientSecret"
              control={control}
              render={({ field }) => (
                <>
                  <Input
                    {...field}
                    id="ZoomClientSecret"
                    type="text"
                    value={field.value || ""}
                  />
                  {/* {errors?.Link?.message ? (
                    <FormFeedback type="invalid" className="d-block">
                      {errors?.Link?.message}
                    </FormFeedback>
                  ) : null} */}
                </>
              )}
            />
          </div>

          <div className="mb-3">
            <Label>Enable</Label>
            <div>
              <Controller
                name="EnableZoom"
                control={control}
                render={({ field }) => (
                  <>
                    <Switch
                      {...field}
                      id="EnableZoom"
                      checked={field.value}
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      className="me-1 mb-sm-8 mb-2"
                      onColor="#626ed4"
                    />
                  </>
                )}
              />
            </div>
          </div>
        </Col>
      </Row>
      <div className="d-flex flex-wrap gap-2">
        <Button color="primary" className="btn" onClick={handleSave}>
          {"Save"}
        </Button>
      </div>
    </FormProvider>
  )
}
export default ZoomTab
